import BranchBaseController from '../common/branch.base.controller'

class BranchallController extends BranchBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, BranchService, $translate, $stateParams, $scope, $location) {

    super(Auth, $state, User, BranchService, Modal, $translate, $stateParams, $location)

    this.id = 'branch.all'
    this.loading = true
    this.branches = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this.searchText = '';
    this.$location = $location;
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(branch) {
    this.$state.go('branch.edit', ({
      id: branch.id
    }))
  }

  delete(branch) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${branch.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(branch.id)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData() {
    const searchObj = this.generateSearchObj();

    this.loading = true;
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total
        this.loading = false
        this.branches = data.results;
      })
      .catch((err) => {
        this.loading = false;
        this.error = err.message;
        this.Modal.errorModal(err.data.message);
      })
  }

  generateSearchObj() {
    return {
      queryText: '%' + this.searchText + '%',
      isQuery: false
    }
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }
  
  toggleExpand(branch) {
    branch.expand = !branch.expand;
  }
}

export default BranchallController;


// WEBPACK FOOTER //
// ./client/app/components/branch/all/branch.all.controller.js